var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"9.45947","x2":"17.5109","y2":"9.45947","className":"stroke-current","key":0}),React.createElement("line",{"x1":"8.52637","y1":"0.487305","x2":"8.52637","y2":"17.9739","className":"stroke-current","key":1})]);
}

Plus.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
